import {
	getHistoryUnitsJson,
	getHistoryUnitsJsonSuccess,
	getUnitsJsonSuccess,
} from "modules/actions/units";
import {RequestState} from "modules/enums";
import {createReducer} from "redux-act";

interface IUnitsStore {
	current: ReturnType<typeof getUnitsJsonSuccess>["payload"];
	past: ReturnType<typeof getHistoryUnitsJsonSuccess>["payload"];
	historyRequestState: RequestState;
}

const defaultState: IUnitsStore = {
	current: [],
	past: [],
	historyRequestState: RequestState.IDLE,
};
export const units = createReducer<IUnitsStore>({}, defaultState);

units.on(getHistoryUnitsJson, (state) => ({
	...state,
	historyRequestState: RequestState.Requested,
}));

units.on(getUnitsJsonSuccess, (state, payload) => {
	return {
		...state,
		current: payload,
	};
});

units.on(getHistoryUnitsJsonSuccess, (state, payload) => {
	return {
		...state,
		past: payload,
		historyRequestState: RequestState.Received,
	};
});
